import brandConfig from '../../config'
import myPagesFormValidation from '../../../../form/shared/mypages/validation'

export default myPagesFormValidation(brandConfig)
